import URLConfig from '@Config/urls/url.config';
import React from "react";
import { Route } from "react-router-dom";
import * as GabManagementModule from '@Modules/terminalManagementSystem/gabManagement/pages';


const GabManagementRoutes = [
  // Bank Menu Routes
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.BANK_MENU.FDK_CONFIGURATION}
    element={<GabManagementModule.FDKConfigurationPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.BANK_MENU.CONFIGURATION}
    element={<GabManagementModule.ConfigurationPage />}
  />,

  // Global Settings Menu Routes
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.GLOBAL_SETTINGS_MENU.GROUP}
    element={<GabManagementModule.GroupPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.GLOBAL_SETTINGS_MENU.FITS_GROUP}
    element={<GabManagementModule.FitsGroupPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.GLOBAL_SETTINGS_MENU.FINANCIAL_INSTITUTES_TABLE}
    element={<GabManagementModule.FitsTablePage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.GLOBAL_SETTINGS_MENU.FDK_VALUES}
    element={<GabManagementModule.FdkValuesPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.GLOBAL_SETTINGS_MENU.DESIGNATION}
    element={<GabManagementModule.DesignationPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.GLOBAL_SETTINGS_MENU.PRINT_SETTING}
    element={<GabManagementModule.PrintSettingPage />}
  />,

  // Terminal Menu Routes
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU.SALES_POINT}
    element={<GabManagementModule.SalesPointPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU.TERMINAL}
    element={<GabManagementModule.TerminalPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU.LOG_EVENT}
    element={<GabManagementModule.LogEventPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU.CAPTURED_CARD}
    element={<GabManagementModule.CapturedCardTerminalPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU.OUT_OF_SERVICE_TERMINAL}
    element={<GabManagementModule.OutOfServiceTerminalPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU.MONITORING}
    element={<GabManagementModule.MonitoringPage />}
  />,
  <Route
    path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU.GAB_TRANSACTION}
    element={<GabManagementModule.GABTransactionPage />}
  />,

];

export default GabManagementRoutes;
